"use strict";

import {isset} from '../js-utilities';
import ManagerHelper from './helpers/manager-helper';
import {generateValueOutput} from "./helpers/calculator-helpers";

// Smoking
export default class SmokingManager {
    constructor(controller, language) {
        this.controller = controller;
        this.language = language;

        this.$smokingSummary = $('#smoking_summary');
        this.$smokingSummaryValue = $('#smoking_summary_value');

        this.$smokingOutputCellLabel = $('#smoking_output_cell_label');
        this.$smokingOutputCellValue = $('#smoking_output_cell_value');
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$smokingOutputCellIcon = $('#smoking_output_cell_icon');

        this.smokingHelper = new ManagerHelper('smoking', this.controller, this.updateSmokingAgeInfluence.bind(this));
    }

    reconfigureSmokingInput() {
        if (this.smokingHelper) {
            this.smokingHelper.configureInput();
        }
    }

    callGenerateSliderGradients() {
        if (this.smokingHelper) {
            this.smokingHelper.callGenerateSliderGradient();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    updateSmokingAgeInfluence(smoking = this.controller.current_values.smoking) {
        if (isset(smoking) && isset(this.controller.current_values.gender)) {
            const response = this.controller.calculator_4.ageChangeForValue('smoking', smoking, this.controller.current_values.fractional_age, this.controller.current_values.gender);
            this.populateSmokingOutput(response);
        } else {
            this.populateSmokingOutput();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    populateSmokingOutput(response) {
        const smokingOutput = generateValueOutput('smoking', response, this.controller);

        this.controller.current_age_changes.smoking = smokingOutput.ageChange;
        this.controller.current_values.smoking_change = smokingOutput.ageChangeText

        this.$smokingSummary.html(smokingOutput.summary);
        this.$smokingSummaryValue.html(smokingOutput.summaryValue);

        this.$smokingOutputCellLabel.html(smokingOutput.outputCellLabel);
        this.$smokingOutputCellValue.html(smokingOutput.outputCellValue).css('color', smokingOutput.outputCellColor);
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$smokingOutputCellIcon.prop('src', smokingOutput.outputCellIcon);

        this.controller.calculate_vascular_age();
    }

    // public method for controller to enable and disable UI controls
    enableControls(enable) {
        this.smokingHelper.enableControls(enable);
    }

}
